export default "__VITE_ASSET__Ba47mHF___"